import Request from "lib/request";

export const init = () => {
  return Request({
    url: "init",
    method: "get"
  });
};
export const getAnnouncements = () => {
  return Request({
    url: "announcements",
    method: "get"
  });
};
